const home = {
  Introduction_title: 'Introduction',
  IntroductionHome1:
    'UTraffic (UTraffic: Urban Traffic Estimation System): An urban traffic forecasting system based on data from the community',
  IntroductionHome2: 'has researched and proposed reasonable solutions,',
  IntroductionHome3: 'applying the power of 4.0 technology',
  IntroductionHome4: 'and',
  IntroductionHome5: 'the power of the community',
  IntroductionHome6: 'to solve',
  IntroductionHome7: 'core, new problems',
  IntroductionHome8: 'and',
  IntroductionHome9: 'not yet well solved',
  IntroductionHome10:
    'by existing solutions, contributing to reducing traffic congestion, improving safety and convenience for participants. Utraffic includes the following outstanding solutions:',
  Outstanding_Solutions1:
    'Traffic data is collected from many sources, the most important of which is the community through mobile and web applications.',
  Outstanding_Solutions2:
    'Estimating and forecasting traffic conditions accurately and in a timely manner using big data analytics and machine learning techniques',
  Outstanding_Solutions3: 'Warning traffic jams for people in a timely manner',
  Outstanding_Solutions4:
    'Supports efficient routing function taking into account traffic conditions',
  Outstanding_Solutions5:
    'Provide statistical information, forecast, support decision-making of managers.',
  Mobile_application: 'Mobile application (Utraffic Mobile)',
  Web_application: 'Web-based application (Utraffic Website)',
  MIS_system:
    'MIS system for the Urban traffic information channel (95.6MHz), the Voice of Ho Chi Minh City (VoH) (VoH Website)',
  Apis: 'Publish APIs and API document (Documents)',
  Feature_title: 'Features',
  Easy_Use: 'Easy to Use',
  Free: 'Free',
  Many_Utilities: 'Many utilities',
  Product: 'A product of HCMUT',
  Easy_Use_Description:
    'Utraffic is designed to provide convenience and ease of use with its mobile and web-based apps',
  Free_Description: 'Utraffic is free to best serve the community',
  Many_Utilities_Description: `UTraffic provides many utilities to the community including sharing traffic data, accessing information about traffic jams, finding the shortest route (in space and over time taking into account current traffic conditions,...),  extracting traffic data for research and development, supporting the processing and storage of traffic information in the VoH's Urban Transport Channel (95.6MHz),...`,
  Product_Description:
    'UTraffic was developed and maintained by a group of students and master’s students of Ho Chi Minh University of Technology (HCMUT)',
  Software_Product_Title: 'Software product',
  Software_Product_Description:
    'UTraffic is a system consisting of the following main software:',
  UTrafficMobile: 'UTrafficMobile',
  UTrafficPortal: 'UTrafficPortal',
  UTrafficMIS: 'UTrafficMIS',
  PublishData_APIs_Documents: 'Publish Data, APIs and Documents',
  UTrafficMobile_Description:
    'The mobile application supports community-based data collection, displays and warns of traffic conditions, supports optimal route finding, etc. Users can download the application for free at ',
  UTrafficPortal_Description:
    'Web application collects, organizes, stores, and analyzes big data to forecast traffic conditions, traffic jams,..., supports optimal route finding. Users access this system at ',
  UTrafficMIS_Description1:
    'The traffic management information system is being used in practice at ',
  UTrafficMIS_Description2: 'The Urban Traffic Channel (95.6MHz) of ',
  UTrafficMIS_Description3:
    'The Voice of Ho Chi Minh City (VOH), in order to best serve the community.',
  PublishData_APIs_Documents_Description:
    'Providing a mechanism to get real-time traffic data, the APIs that develop this system, and related documents, for researchers and software developers to use in research and development. Users can survey these utilities on the main menu of the website.',
  Members: 'Members',
};
export default home;
